var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_508_2",
    "data-name": "Component 508 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13753",
    "data-name": "Rectangle 13753",
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40179",
    "data-name": "Path 40179",
    d: "M1.251,5.135c0-2.623.166-3.884,3.884-3.884s3.884,1.26,3.884,3.884c0,1.323,0,2.264-.546,2.942-.629.782-1.789.942-3.338.942S2.427,8.858,1.8,8.076c-.546-.678-.546-1.617-.546-2.917M5.135,2.507c-2.628,0-2.628.249-2.628,2.628v.023a4.159,4.159,0,0,0,.269,2.13c.264.327.991.474,2.359.474s2.1-.146,2.36-.473a4.178,4.178,0,0,0,.268-2.133C7.762,2.756,7.762,2.507,5.135,2.507Z",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40180",
    "data-name": "Path 40180",
    d: "M13.471,5.135c0-2.623.165-3.884,3.884-3.884s3.884,1.26,3.884,3.884c0,1.325,0,2.264-.547,2.943-.629.781-1.789.941-3.337.941s-2.708-.16-3.338-.943c-.546-.679-.546-1.619-.546-2.919m3.884-2.649c-2.628,0-2.628.249-2.628,2.628v.022A4.163,4.163,0,0,0,15,7.288c.264.328.991.475,2.359.475s2.1-.146,2.359-.473a4.159,4.159,0,0,0,.269-2.131C19.982,2.756,19.982,2.507,17.355,2.507Z",
    transform: "translate(-1.987)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40181",
    "data-name": "Path 40181",
    d: "M1.251,17.355c0-2.623.166-3.884,3.884-3.884s3.884,1.261,3.884,3.884c0,1.324,0,2.264-.546,2.942-.629.782-1.789.942-3.338.942S2.427,21.078,1.8,20.3c-.546-.677-.546-1.617-.546-2.917m3.884-2.651c-2.628,0-2.628.249-2.628,2.628v.023a4.159,4.159,0,0,0,.269,2.13c.264.327.991.474,2.359.474s2.1-.146,2.36-.473a4.178,4.178,0,0,0,.268-2.133C7.762,14.976,7.762,14.727,5.135,14.727Z",
    transform: "translate(0 -1.987)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40182",
    "data-name": "Path 40182",
    d: "M13.471,17.355c0-2.623.165-3.884,3.884-3.884s3.884,1.261,3.884,3.884c0,1.325,0,2.265-.547,2.943-.629.781-1.789.941-3.337.941s-2.708-.16-3.338-.943c-.546-.678-.546-1.618-.546-2.919m3.884-2.649c-2.628,0-2.628.249-2.628,2.628v.022A4.163,4.163,0,0,0,15,19.508c.264.328.991.475,2.359.475s2.1-.146,2.359-.473a4.159,4.159,0,0,0,.269-2.131C19.982,14.976,19.982,14.727,17.355,14.727Z",
    transform: "translate(-1.987 -1.987)",
    fill: "#1a1818"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid-icon.3c9b6d6e.svg";
export { ForwardRef as ReactComponent };